import React from "react";
import { Dropdown } from "react-bootstrap";
import { Avatar } from "../../widgets";

const MultiSelectAvatar = ({ options, selected, maxDisplay, onSelect, maxSelection, disabled }) => {
    const avatarOptions = [], dropdownOptions = [];

    options.forEach((e, i) => {
        if (i < (options.length === maxDisplay ? maxDisplay : maxDisplay - 1))
            avatarOptions.push(e);
        else
            dropdownOptions.push(e);
    });


    const isDisabled = id => {
        if (disabled.indexOf(id) < 0)
            return maxSelection ? (maxSelection <= selected.length && selected.indexOf(id) < 0) : false;
        return true;
    };

    return <div className="multi-select-avatar">
        {avatarOptions.map(item => {
            const disable = isDisabled(item.id);
            return <Avatar
                key={item.id}
                name={item.label}
                className={`img-avatar ${selected.indexOf(item.id) >= 0 && "selected"} ${disabled.indexOf(item.id) >= 0 && "changed"} ${disable && "disabled"}`}
                {...!disable && {
                    onClick: () => onSelect(item, selected.indexOf(item.id) < 0)
                }} />
        })}

        {dropdownOptions.length > 0 &&
            <Dropdown>
                <Dropdown.Toggle as="div">
                    <Avatar
                        name={`+${dropdownOptions.length}`}
                        autoTitle="false"
                        color="gray"
                        fullText={true}
                        className={`img-avatar avatar-dropdown 
                        ${(dropdownOptions.filter(e => selected.indexOf(e.id) >= 0).length > 0) ? "selected" : ""}`}
                    />
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropdown-menu">
                    {dropdownOptions.map(item =>
                        <AvatarItem
                            key={item.id}
                            {...{ item, selected, disabled: isDisabled(item.id), onSelect }}
                        />)}
                </Dropdown.Menu>
            </Dropdown>}
    </div>;
};

const AvatarItem = ({ item, selected, disabled, onSelect }) =>
    <div key={item.id} className={`dropdown-item-custom ${disabled && "disabled"}`}>
        <label>
            <span>
                <input
                    type="checkbox"
                    checked={selected.indexOf(item.id) >= 0}
                    disabled={disabled}
                    onChange={e => onSelect(item, e.target.checked)}
                />
            </span>
            <span>
                <Avatar
                    name={item.label}
                    className="img-avatar"
                />
            </span>
            <span className="item-text">{item.label}</span>
        </label>
    </div>;

export default MultiSelectAvatar;